import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/digiStrategyDevelopmentData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const DigitalMarketingStrategyDevelopment = () => {
  useMetaTags({
    title: "Expert Digital Marketing Strategy Development for Online Growth",
    description:
      "Boost your online presence with expert digital marketing strategy development. Get tailored strategies to drive traffic, leads, and business growth.",
    keywords:
      "digital marketing strategy development, digital marketing strategy, digital marketing strategy services, digital marketing strategy solutions, marketing strategy, brand strategy, marketing strategy plan, social media strategy, digital marketing strategy, marketing strategist, marketing strategy services, social media marketing strategy, business marketing strategy",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Digital Marketing Strategy Development
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/digitalMarketingStrategyImg2.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  At Warrgyizmorsch we focus on developing smart, scalable
                  digital marketing solutions for your business needs. Whether
                  you are a first time player or you have an already established
                  marketing team digital marketing strategy services which you
                  would like us to improve we take a data backed creative and
                  experienced approach to what we do which we put forward across
                  all platforms.
                </p>
              </div>
            </div>
            {/* Our Digital Marketing Strategy Services Include  */}
            <Handle_Largedata_section LargeData={LargeData} />

            {/* Why Your Business Needs a Digital Marketing Strategy */}
            <Custom_section data={CustomSection} />

            {/* Benefits of a Digital Marketing Strategy */}
            <Benefits_section data={BenefitSection} />

            {/* Why Warrgyizmorsch Is the Best Choice for Digital Marketing Strategy Development?  */}
            <Boost_section data={BoostSection} />

            {/* Why Work with Us for Digital Marketing Strategy?  */}
            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default DigitalMarketingStrategyDevelopment;
